export function ProductsFeedsEmpty() {
  return (
    <tr>
      <td colSpan={9} style={{ height: 200 }}>
        <h3>No products feeds available.</h3>
      </td>
    </tr>
  );
}
